export default "﻿<div>\n    Das ist nicht der richtige Generic Dialog!!\n</div>\n"